import { gql, type TypedDocumentNode } from '@apollo/client';
import type {
  TagLayoutSearchQuery,
  TagLayoutSearchQueryVariables,
  TagLayoutsQuery,
  TagLayoutsQueryVariables,
} from 'types/graphql';

/** Rows per tag-layout picker page (P7-R35). An org with more reaches the rest through the server search. */
export const TAG_LAYOUT_PAGE_SIZE = 50;

/**
 * The `/internal/pallet-tags` list read: the first page of `tagLayoutPage`, oldest first (creation order, the
 * closest stable match to the unordered `tagLayouts(take: 5000)` it replaces, so the first row stays the default).
 */
export const TAG_LAYOUTS_QUERY: TypedDocumentNode<TagLayoutsQuery, TagLayoutsQueryVariables> = gql`
  query TagLayoutsQuery {
    tagLayoutPage(input: { first: 50, sortItems: [{ field: "id", sort: "asc" }] }) {
      totalCount
      edges {
        node {
          id
          name
          schema
          isLastUsed
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;

/** Search-as-you-type for every tag-layout picker: the same row selection as the first pages. */
export const TAG_LAYOUT_SEARCH_QUERY: TypedDocumentNode<TagLayoutSearchQuery, TagLayoutSearchQueryVariables> = gql`
  query TagLayoutSearchQuery($input: StandardPageInput!) {
    tagLayoutPage(input: $input) {
      edges {
        node {
          id
          name
          schema
        }
      }
    }
  }
`;

/** List-page create (operation name kept for telemetry). */
export const CREATE_TAG_LAYOUT = gql`
  mutation CreateTagLayoutMutation($input: CreateTagLayoutInput!) {
    createTagLayout(input: $input) {
      id
    }
  }
`;

/** List-page update (operation name kept for telemetry). */
export const UPDATE_TAG_LAYOUT = gql`
  mutation UpdateTagLayoutMutation($id: Int!, $input: UpdateTagLayoutInput!) {
    updateTagLayout(id: $id, input: $input) {
      id
    }
  }
`;

/** Editor create (operation name kept for telemetry). */
export const CREATE_TAG_LAYOUT_FROM_EDITOR = gql`
  mutation CreateTagLayoutFromEditorMutation($input: CreateTagLayoutInput!) {
    createTagLayout(input: $input) {
      id
    }
  }
`;

/** Editor update (operation name kept for telemetry). */
export const UPDATE_TAG_LAYOUT_FROM_EDITOR = gql`
  mutation UpdateTagLayoutFromEditorMutation($id: Int!, $input: UpdateTagLayoutInput!) {
    updateTagLayout(id: $id, input: $input) {
      id
    }
  }
`;
